module.exports = fox._r("images/relate_good.gif", __webpack_public_path__ + "images/relate_good.gif");


//////////////////
// WEBPACK FOOTER
// ./images/relate_good.gif
// module id = 1098
// module chunks = 4